<template>
  <v-container fluid>
    <!-- Search bar -->
    <v-row align="center">
      <v-col cols="6" class="text-left mb-2">
        <v-text-field v-model="search" label="Recherche" single-line hide-details></v-text-field>
      </v-col>
      <v-col cols="6" class="text-right mb-2">
        <!-- Button to open add notice dialog -->
        <v-btn small color="primary" dark @click="openDialog">
          <v-icon small class="mr-2">mdi-plus</v-icon>AJOUTER UNE FICHE
        </v-btn>
      </v-col>
    </v-row>

    <!-- Dialog for adding new notice -->
    <v-dialog v-model="dialog" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          <h4 class="headline">{{ formTitle }}</h4>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="fiche.libelle" label="Libelle / Version de la fiche"></v-text-field>
          <v-file-input v-model="fiche.file" placeholder="Charger le fichier" label="Joindre la fiche de demande"
            multiple prepend-icon="mdi-paperclip">
            <template v-slot:selection="{ text }">
              <v-chip small label color="primary">{{ text }}</v-chip>
            </template>
          </v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-1" text @click="closeDialog">
            ANNULER L'OPÉRATION
          </v-btn>
          <v-btn small color="green darken-1" text @click="addFiche">
            AJOUTER LA FICHE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Data table for displaying data -->
    <v-data-table locale="fr" :headers="headers" :search="search" no-data-text="Aucune fiche trouvée"
      :items="this.$store.getters['Auth/getFicheQuitus']" @click:row="goto" class="elevation-1 mb-5 px-5">
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: { DatePicker },
  data: () => ({
    search: "",
    dialog: false,
    formTitle: "Ajouter une fiche",
    fiche: {
      libelle: "",
      file: []
    },

    headers: [
      { text: "ID / Libelle / Version", align: "start", sortable: false, value: "libelle" },
      { text: "Nom de la fiche", sortable: false, value: "fileName" },
    ],
  }),
  created() {
    this.$store.dispatch("Auth/loadAllFichesQuitus");
    this.$store.dispatch("Auth/getData");
  },
  methods: {
    ...mapActions({
      loadAllFiches: "Auth/loadAllFichesQuitus",
      addFicheModele: "Auth/addFicheDemandeQuitus"
    }),
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    goto(value) {
      const { id } = value;
      this.$router.push({ name: "RegshowModele_quitus", params: { id: id } });
    },
    addFiche() {
      const data = new FormData();
      data.append("libelle", this.fiche.libelle);
      if (this.fiche.file) {
        data.append("file", this.fiche.file[0]);
      } else {
        data.append("file", null);
      }

      this.addFicheModele(data);

      this.fiche.nomCabinet = "";
      this.fiche.file = [];
      this.dialog = false;
    },

  }
};
</script>

<style>
</style>